import React from "react";
import { 
    ToggleDiv,
    ToggleSpan
} from './styles';
import './toggle-style.css';

const ToggleButton = ({...props}) => {

    return(
        <ToggleDiv>
            <input type="checkbox" id="switch" checked={props.isBusiness} onChange={props.function}/>
            <label htmlFor="switch" id="toggle"></label>
            <ToggleSpan>{props.isBusiness ? 'Business': 'Private'}</ToggleSpan>
        </ToggleDiv>
    )
}
export default ToggleButton;
